import { msalInstance } from './authConfig';
import { clearPreviewScope } from './customerPreview';
import { demoSignOut, isDemoMode } from './demoSession';
import {
  hasCustomerSession,
  PORTAL_BASENAME,
  signOut as signOutCustomer,
} from './portal/customerSession';

/**
 * Ends whichever kind of session this tab is running, without the caller having to know which.
 *
 * Two exist and they end differently: an internal session is an Entra one, so signing out means a
 * round trip to Entra to drop its session cookie too; a customer session is ours, so it means
 * revoking the refresh token server-side and returning to the portal's own sign-in screen. Calling
 * `instance.logoutRedirect()` on a customer session — which is what every sign-out in the app did
 * before local credentials existed — would bounce a county contact to a Microsoft page they have
 * no account on.
 */
export async function signOutCurrentSession() {
  clearPreviewScope();

  if (isDemoMode) {
    demoSignOut();
    return;
  }

  if (hasCustomerSession()) {
    await signOutCustomer();
    // A full navigation rather than a history push: it guarantees every bit of in-memory state
    // from the signed-in shell is gone, which is the same guarantee the Entra redirect gives.
    window.location.assign(PORTAL_BASENAME);
    return;
  }

  await msalInstance.logoutRedirect();
}
